import { render, staticRenderFns } from "./MarcaDelete.vue?vue&type=template&id=70d9cd3e&"
import script from "./MarcaDelete.vue?vue&type=script&lang=js&"
export * from "./MarcaDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports